import { FC } from 'react';

import { useFormContext } from 'react-hook-form';

import {
  OVERBITE_OPTION_VALUES,
  OVERBITE_OPTIONS
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import CorrectOpenBite from './CorrectOpenBite';
import ImproveDeepBite from './ImproveDeepBite';
import { If } from '../Generics';
import RhfRadioGroup from '../RadioGroup/RhfRadioGroup/RhfRadioGroup';
interface Props {
  isDisabled?: boolean;
}

const OverBite: FC<Props> = ({ isDisabled }) => {
  const { watch } = useFormContext();
  const watchOverBite = watch(
    'treatmentSpecifications.ZenClearUltra.overbite.overBite'
  );

  return (
    <div>
      <RhfRadioGroup
        inputProps={{ disabled: isDisabled }}
        title={translate('prescription.step12_overbite')}
        options={OVERBITE_OPTIONS}
        name='treatmentSpecifications.ZenClearUltra.overbite.overBite'
        className=' flex flex-row space-x-16'
        radioClassName='border-RADIO_BORDER'
        radioItemFont='md:text-17px text-sm '
      />
      <If
        condition={watchOverBite === OVERBITE_OPTION_VALUES.CORRECT_OPEN_BITE}
      >
        <div className='bg-GRAY5 p-4 rounded-2xl mt-4 w-full'>
          <CorrectOpenBite isDisabled={isDisabled} />
        </div>
      </If>
      <If
        condition={watchOverBite === OVERBITE_OPTION_VALUES.IMPROVE_DEEP_BITE}
      >
        <div className='bg-GRAY5 p-4 rounded-2xl w-full'>
          <ImproveDeepBite isDisabled={isDisabled} />
        </div>
      </If>
    </div>
  );
};
export default OverBite;
